export var DEFAULT_DURATION = 10;
export var DEFAULT_ALERT_TITLE_UI = 'При выполнении действия возникла ошибка:';
export var DEFAULT_ALERT_TITLE_API = 'При выполнении запроса возникла ошибка:';
